import { render, staticRenderFns } from "./SwitchUserContainer.vue?vue&type=template&id=6cb0a1f8"
import script from "./SwitchUserContainer.vue?vue&type=script&lang=js"
export * from "./SwitchUserContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports